module.exports = __webpack_public_path__ + "static/img/1.f5207f82.png";